import React, { FC } from "react";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import {
  BlockHeader,
  HeaderLevel,
} from "@app/components/common/block-header/BlockHeader";
import { useBlogTags } from "@app/hooks/use-blog-tags/useBlogTags";
import { IRichText, TextType, IAsset } from "@app/models/storyblok/basic";
import { useFormatDate } from "@app/hooks";
import { Breadcrumbs } from "./components/breadcrumbs/Breadcrumbs";

type Props = {
  slug: string;
  header: IRichText<TextType>;
  category: string;
  tags: string[];
  date: string;
  author: string;
  image: IAsset;
};

export const Hero: FC<Props> = ({
  slug,
  header,
  category,
  tags,
  image,
  date,
  author,
}) => {
  const localizedTags = useBlogTags(tags);
  const formatedDate = useFormatDate(date);

  return (
    <>
      <Breadcrumbs {...{ slug, category }} />
      <div
        className={classNames(
          "mt-5 mb-15 w-full",
          "xl:mt-7.5 xl:flex xl:items-center xl:justify-between",
          "xxl:mb-40",
        )}
      >
        <GatsbyImage
          image={getGatsbyImage(image.filename, { layout: "fullWidth" })}
          alt={image.alt}
          className={classNames(
            "w-full rounded-lg",
            "xl:order-last xl:w-1/2 xl:flex-initial",
          )}
        />
        <div
          className={classNames(
            "relative space-y-6",
            "xl:order-first xl:w-full xl:max-w-[460px] xl:flex-initial",
          )}
        >
          <div
            className={classNames(
              "mt-6 space-y-6",
              "xl:absolute xl:mt-0 xl:-translate-y-full",
            )}
          >
            <div className={classNames("flex flex-wrap items-center gap-2.5")}>
              {localizedTags.map((tag) => (
                <div
                  key={tag.uuid}
                  className={classNames(
                    "bg-dark text-base-400 rounded px-4 py-0.75",
                  )}
                >
                  {tag.name}
                </div>
              ))}
            </div>
            <div className={classNames("text-base-400 flex gap-5")}>
              <span>By {author}</span>
              <span>{formatedDate}</span>
            </div>
          </div>
          <BlockHeader
            richText={header}
            headerLevel={HeaderLevel.H1}
            className={classNames("text-large text-primary-content")}
          />
        </div>
      </div>
    </>
  );
};
